import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { KeyStoreService } from "../key-store.service";
import { FormDataService } from '../form-data.service';
import { SshAgentExtensionService } from '@Common/util';
import PrivateKey from '../../private-key';

@Component({
standalone: false,
  selector: 'fx-ssh',
  templateUrl: './ssh.component.html',
  styleUrls: ['./ssh.component.css']
})
export class SshComponent implements OnInit {
  
  @Input () baseStage = 'login';
  @Input () successStages = ['success'];
  @Input () exec;
  @Input () data:any = {};
  @Input() adminLogin;
  @Input () set disable (b) {
    this.setDisable (b);
  };
  @Output () success = new EventEmitter ();
  @Output () cancel = new EventEmitter ();
  @Output () error = new EventEmitter ();
  @Output () unknownStage = new EventEmitter ();
  @Output() intermediateStage = new EventEmitter();
  @ViewChild ('pubKey', {static: false}) publicKeyStage;
  @ViewChild ("pw", {static: false}) pw;
  @ViewChild ("kb", {static: false}) kb;
  gen;
  pubkeydone;
  currentStage;
  _disable;
  err;
  handled;
  currentKey;
  pk;
  constructor(public ks: KeyStoreService, private cdr: ChangeDetectorRef, private sshAgent: SshAgentExtensionService) { }

  ngOnInit() {
    this.currentStage = this.baseStage;
    console.log('reset')    
  }
  async ngOnChanges(changes: SimpleChanges) {
    if(!changes?.data)
      return;

    await this.switchStage(changes.data.currentValue);
    this.cdr.detectChanges();
    
  }
  stage () {
    return this.data.stage || this.baseStage;
  }
  async handleDecrypted(pk) {
    this.pk = pk;
    this.handle({
        authtoken: this.data.authtoken,
        publicKey: this.pk.getPublicKeyBlob()
    })
  }
  async handle (d) {
    this.setDisable (true);
    try {
      if(!this.handled) {
        this.handled = true;
      }
        
      let r = await this.exec (d)
      this.setDisable (false);
      this.data = r;
      await this.switchStage (r);
    } catch(e) {
        
      if(e.name === 'REAUTH_ERROR') {
        this.currentStage = 'login';
        this.data = e.data;
        this.setDisable (false);
        await this.switchStage (this.data);
        return;
      }
      this.data.stage = this.baseStage;
      this.currentStage = this.baseStage;
      this.error.emit (e);
      this.err = e;
      this.setDisable (false);
    }
    this.cdr.detectChanges();
  }
  onCancel ($event) {
    this.setDisable (false);
    this.cancel.emit ($event);
  }
  onError ($event) {
    this.setDisable (false);
    this.error.emit ($event);
    this.err = $event;
  }
  async switchStage (r) {
    //ssh can have multiple success stages as defined by the consumer
    if (this.successStages.indexOf (r.stage) >= 0) {
      this.currentStage = r.stage;
      if(r.csrf) {
        localStorage.csrf = r.csrf;
      }
     
      return this.success.emit (r);
    }
    this.intermediateStage.emit(r.stage);
    switch (r.stage) {
      case 'login':
        break;
      case 'sign':
        this.currentStage = r.stage;

        if(r.pubKey) {
          try {
            if(this.pk) {
                this.handle ({ 
                    authtoken: r.authtoken,
                    signature: await (this.pk.sign(r.signData, r.flags))
                }); 
                return;
            }
            this.sshAgent.enabled();
            let c:any = await this.sshAgent.sign(r)
              
            this.handle ({
                authtoken: r.authtoken,
                signature: c.signature || ''
            });
            return;
          } catch(e) {
            console.log(e);
            this.handle ({
                authtoken: r.authtoken,
                signature: ''
              });
              return;
          }
          
        }
        this.handle ({
            authtoken: r.authtoken,
            signature: ''
          });
          return;

       
        return 
      case "server":
        this.currentStage = r.stage;
        return;
      case "banner":
        this.currentStage = r.stage;
        return;
      case "password":
        if (this.currentStage === r.stage) { 
          this.pw.update ("Password failed. Try again."); 
        }
        this.currentStage = r.stage;
        return;
      case "keyboard-interactive":
        if (this.currentStage === r.stage) { this.kb.update (); }
        this.currentStage = r.stage;
        return;
      case 'public-key': 
          try {
            if(this.pk) {
                throw new Error('Using Browser keys');
            }
            this.sshAgent.enabled();
            let c:any = await this.sshAgent.requestIdentities(r)
            await this.handle ({
                authtoken: r.authtoken,
                identities: c
            });
            return;
          } catch(e) {
                if(this.pk) { 
                     this.ks.next();
                } else {
                    await this.ks.reset();
                    this.ks.start();
                }
                if(!this.ks.current()) {
                    this.handle({ 
                        authtoken: r.authtoken,
                        publicKey:  ''
                    });
                    return;
                }
                if(this.ks.isEncrypted()) {
                    return;
                }
                this.pk = this.ks.getKey();
                this.handle({ 
                    authtoken: r.authtoken,
                    publicKey: this.pk?.getPublicKeyBlob() || ''
                });
                return;
          }

      default: 
        this.currentStage = r.stage;
        this.unknownStage.emit (r);
        return;
    }
  }
  setDisable (b) {
    this._disable = b;
    this.cdr.detectChanges ();
  }
}
